export default __webpack_public_path__ + "static/media/home-acropass-hiaru.5a0b8ebf.png";